import "../styles/IndicatorsStyle.css";



import { get_info_element } from "./Indicators";

const GeographicBackground = ({
  koppen_climate_clas_check, 
  setKoppen_climate_clas_check
}) => {


  const oncheck_koppen_climate = () => {
    setKoppen_climate_clas_check(!koppen_climate_clas_check);
  };





  return (
    <div className="indicator-module">
      <p className="Indicator-names">GEOGRAPHIC BACKGROUND</p>

      <div className="selection-section">
        <div className="selection-section-header">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={koppen_climate_clas_check}
              onChange={oncheck_koppen_climate}
              disabled={false}
            />
            <span className="slider round"></span>
          </label>
          <p className="indicator-description">Koppen Climate Classification</p>
          {get_info_element()}
        </div>
      </div>


    
      
    </div>
  );
};

export default GeographicBackground;
